import { MessageSquare, Eye, Heart, MousePointerClick } from 'lucide-react';

interface MetricsBarProps {
  publishedPosts?: number;
  impressions?: number;
  reactions?: number;
  clicks?: number;
}

export function MetricsBar({
  publishedPosts = 0,
  impressions = 0,
  reactions = 0,
  clicks = 0,
}: MetricsBarProps) {
  // Format numbers with commas
  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toLocaleString();
  };

  const metrics = [
    {
      label: 'Published Posts',
      value: publishedPosts,
      icon: MessageSquare,
      color: 'text-cmp-ink-3',
    },
    {
      label: 'Impressions',
      value: impressions,
      icon: Eye,
      color: 'text-cmp-ink-3',
    },
    {
      label: 'Reactions & Comments',
      value: reactions,
      icon: Heart,
      color: 'text-cmp-ink-3',
    },
    {
      label: 'Clicks',
      value: clicks,
      icon: MousePointerClick,
      color: 'text-cmp-ink-3',
    },
  ];

  return (
    <div className="bg-core-dark mt-1 mx-1 mb-0 flex-shrink-0">
      <div className="px-6 py-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {metrics.map((metric, index) => {
            const Icon = metric.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-3 p-3 bg-panel rounded-lg border border-cmp-line hover:border-primary-light transition-colors"
              >
                <div className={`${metric.color} flex-shrink-0`}>
                  <Icon className="w-6 h-6" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-cmp-mono text-[0.68rem] tracking-[0.14em] uppercase text-cmp-ink-3 mb-1">
                    {metric.label}
                  </p>
                  <p className="font-cmp-serif text-2xl tracking-[-0.02em] text-cmp-ink truncate">
                    {formatNumber(metric.value)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
